import _ from 'lodash';
import React, {useState, useRef} from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {TabComponent} from 'componentLibrary/modules/TabComponent';
import {withRouter} from 'react-router-dom';
import DynamicTable from 'componentLibrary/layout/dynamicTable';

export const RecipientTargetTableWrapper = (props) => {
  const {tabs} = props;
  const initialTab = _.get(tabs, '[0].id', '');
  const [activeTabId, setActiveTabId] = useState(initialTab);
  const tab = _.find(tabs, (tab) => tab.id === activeTabId);
  const tableProps = _.get(tab, 'tableProps', {});

  const tableRef = useRef(null);

  const setActiveTab = (tabId) => {
    setActiveTabId(tabId);
  };

  return (
    <>
      <TabComponent tabs={tabs} setActiveTab={setActiveTab} initialTab={activeTabId} />
      <>
        <div ref={tableRef}>
          <DynamicTable {...tableProps}></DynamicTable>
        </div>
      </>
    </>
  );
};

const RecipientTargetTableWrapperWithRouter = withRouter(RecipientTargetTableWrapper);

export default connectDynamic(RecipientTargetTableWrapperWithRouter);
